<template>
  <v-dialog v-model="toggle" width="500">
    <v-card class="recuperar-senha">
      <!-- <v-app-bar class="" color="blue" dark dense> -->
        <!-- <div class="dialog-recover-password-titulo-text"> -->
          <!-- <v-toolbar-title>Recuperação de senha</v-toolbar-title> -->
        <!-- </div> -->
      <!-- </v-app-bar> -->
      <div class="dialog-recover-password-titulo-text d-flex justify-end">
          <span @click="closeModal" class="fechar">X</span>
      </div>
      <div class="d-flex justify-center">
        <img :src="brand.logo" alt="Logo Gestão Afiliados" class="logo mb-5" />
      </div>
      <!-- <p class="card-login-texto">Enviaremos um email de recuperação.</p> -->
      <p class="card-login-texto text-center">Enviaremos um email de recuperação.</p>
      <v-form>
        <v-card-text>
          <p class="card-login-texto">Digite aqui o e-mail utilizado!</p>
          <v-text-field 
            label="E-mail" 
            dark
            height="30px"
            filled
            persistent-hint
            v-model="email"
            outlined
            prepend-inner-icon="mdi-account-circle-outline"
            :error-messages="usernameErrors"
            @input="$v.email.$touch()" 
            @blur="$v.email.$touch()" 
            />
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn type="submit" dark color="primary" @click.prevent="sendRecoverPasswordEmail" class="login-btn" tile :loading="loading">Enviar email de recuperação</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import Events from '@/core/service/events'
import { required, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import variables from '@/assets/styles/helpers/_variables.scss'
import brand from '@/core/brand'

export default {
  name:'RecoverPassword',
  data: () => ({
    toggle: false,
    username: '',
    email: '',
    loading: false,
    snackbar: {
      toggle: false,
      type: null,
      msg: null
    },
  }),
  watch: {
    email (e) {
      this.email = e.toLowerCase().trim()
    }
  },
  mounted () {  //É como um observer, esta sempre na escuta
    this.openRecoverPasswordModal()
  },
  computed: { //É atualizado sempre que o estado da loja muda
    variables: () => variables,
    brand: () => brand,
    usernameErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.required && errors.push('E-mail é obrigatório.')
      !this.$v.email.email && errors.push('E-mail inválido.')
      return errors
    }
  },
  methods: {
    ...mapActions('auth', ['recoverPassword']),
    sendRecoverPasswordEmail () {
      const self = this
      this.loading = true

      self.recoverPassword({email: self.email.toLocaleLowerCase().trim()}).then(() => {
        this.loading = false
        successSnackbar('E-mail enviado com sucesso')
        this.closeModal()
        return true
      }).catch(e => {
        this.loading = false
        errorSnackbar(e.error)
        return false
      })
    },

    closeModal(){
      this.toggle = false
      this.email = ''
      this.$v.email.$reset()
    },

    openRecoverPasswordModal () {
      Events.$on('auth::openModalRecoverPassword', () => {
        this.toggle = true
      })
    }
  },
  
  validations () {
    return {
      email: {required, email}
    }
  }
}
</script>

<style lang="scss" scoped>
.recuperar-senha {
  background: #1D1D29;
  color: #F5F5F5;
  padding: 20px;
}

.v-text-field--filled:not(.v-text-field--single-line)::v-deep input {
  margin-top: 0;
}

.dialog-recover-password {
  color: red($color: #000000);
  &-titulo-text{
    align-items: center;
    justify-content: space-between;
    display: flex;
    width: 100%;
  }
}

.fechar {
  cursor: pointer;
  padding-right: 10px;
  font-weight: bold;
}

</style>